import { Chip, CircularProgress, useTheme } from "@mui/material";
import {
  BlockOutlined,
  CheckCircleOutline,
  ErrorOutline,
  ScheduleOutlined,
  WarningAmberOutlined,
} from "@mui/icons-material";

export const SEND_STATUS = {
  PENDENTE: 0,
  ACEITO: 1,
  FALHA_TEMPORARIA: 2,
  FALHA_DEFINITIVA: 3,
  CANCELADO: 4,
  ENVIANDO: 5,
};

const SEVERITY_ORDER = [3, 2, 5, 0, 1, 4];

export const worstStatus = (statuses: number[]) =>
  SEVERITY_ORDER.find((s) => statuses.includes(s));

const LABELS: Record<number, string> = {
  0: "Pendente",
  1: "Enviado com sucesso",
  2: "Falhou, tentando de novo",
  3: "Falha no envio",
  4: "Cancelado",
  5: "Enviando",
};

export function useStatusColor() {
  const theme = useTheme();
  return (status: number | undefined) => {
    switch (status) {
      case 1:
        return theme.palette.success.main;
      case 2:
        return theme.palette.warning.main;
      case 3:
        return theme.palette.error.main;
      case 5:
        return theme.palette.info.main;
      default:
        return theme.palette.text.disabled;
    }
  };
}

export default function SendStatusChip({ status }: { status: number }) {
  const colorOf = useStatusColor();
  const color = colorOf(status);
  const icon = {
    0: <ScheduleOutlined />,
    1: <CheckCircleOutline />,
    2: <WarningAmberOutlined />,
    3: <ErrorOutline />,
    4: <BlockOutlined />,
    5: <CircularProgress size={12} color="inherit" />,
  }[status];
  return (
    <Chip
      size="small"
      variant="outlined"
      icon={icon}
      label={LABELS[status] ?? "—"}
      sx={{
        color,
        borderColor: color,
        "& .MuiChip-icon": { color, fontSize: 16, ml: "6px" },
      }}
    />
  );
}
